<influencer-module-container 
    [title]="'INFLUENCER.insight.channel_reach.title' | translate" 
    [tooltip]="'info_box.measure.platform_reach' | translate"
    [hasNoData]="hasNoData"
    [isFetchingData]="isFetchingData"
    [placeholderWidth]="301">

    <div class="channel-reaches-container">
        <div *ngIf="channelReachItems" class="channel-reach-content">
            <div class="row channel-reach-row">
                <div *ngFor="let item of channelReachItems, trackBy: channelReachItemTrackBy" class="col-3 channel-reach-col">
                    <channel-reach-item [item]="item"></channel-reach-item>
                </div>
            </div>
        </div>

        <div *ngIf="showChannelSelector" class="channel-selector-area">
            <div class="channel-selector-title">{{'INFLUENCER.insight.channel_reach.choose_channels' | translate}}</div>
            <div class="channel-selector-container">
                <ng-select #channelSelector [items]="channelSource"
                    bindValue="channelId" bindName="channelName"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [clearable]="false"
                    [searchable]="false" 
                    [ngModel]="otherSelectedChannelIds"
                    (change)="onSelectionChange($event)">
        
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="d-flex flex-row dm-source-selection-container">
                          <div class="source-platform-image {{item.platformName}}-icon"></div>
                          <div class="source-name-wrapper">{{item.channelName}}</div>
                        </div>
                      </ng-template>
        
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    </ng-template>
                </ng-select>
            </div>
        </div>
    </div>
</influencer-module-container>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-reach/channel-reach.component.html